function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "iconos_51_"
}, /*#__PURE__*/React.createElement("rect", {
  x: 149.905,
  y: 561.15,
  width: 133.875,
  height: 47.812
}), /*#__PURE__*/React.createElement("rect", {
  x: 302.905,
  y: 561.15,
  width: 133.875,
  height: 47.812
}), /*#__PURE__*/React.createElement("rect", {
  x: 455.905,
  y: 561.15,
  width: 133.875,
  height: 47.812
}), /*#__PURE__*/React.createElement("rect", {
  x: 73.405,
  y: 494.213,
  width: 133.875,
  height: 47.812
}), /*#__PURE__*/React.createElement("rect", {
  x: 226.405,
  y: 494.213,
  width: 133.875,
  height: 47.812
}), /*#__PURE__*/React.createElement("rect", {
  x: 379.405,
  y: 494.213,
  width: 133.875,
  height: 47.812
}), /*#__PURE__*/React.createElement("rect", {
  x: 532.405,
  y: 494.213,
  width: 57.375,
  height: 47.812
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.405,434.772v40.315h57.375v-13.904C109.552,456.709,90.102,447.462,73.405,434.772z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 73.405,
  y: 561.15,
  width: 57.375,
  height: 47.812
}), /*#__PURE__*/React.createElement("path", {
  d: "M160.663,464.33c-3.634,0-7.191-0.277-10.758-0.545v11.303H283.78v-47.812h-26.785 C231.387,450.235,197.68,464.33,160.663,464.33z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 302.905,
  y: 427.275,
  width: 133.875,
  height: 47.812
}), /*#__PURE__*/React.createElement("rect", {
  x: 455.905,
  y: 427.275,
  width: 133.875,
  height: 47.812
}), /*#__PURE__*/React.createElement("path", {
  d: "M360.28,408.15v-47.812h-60.903c-5.154,17.566-13.579,33.698-24.538,47.812H360.28z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 379.405,
  y: 360.338,
  width: 133.875,
  height: 47.812
}), /*#__PURE__*/React.createElement("rect", {
  x: 532.405,
  y: 360.338,
  width: 57.375,
  height: 47.812
}), /*#__PURE__*/React.createElement("path", {
  d: "M302.905,294.204c1.482,8.291,2.391,16.783,2.391,25.494c0,7.325-0.727,14.478-1.779,21.516H436.78V293.4H302.905V294.204 z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 455.905,
  y: 293.4,
  width: 133.875,
  height: 47.812
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.163,163.312c-7.688,9.706-9.438,26.086-9.219,40.163c0.067,4.112,0.277,8.033,0.564,11.504 c0.363,4.293,0.822,7.927,1.186,10.461l1.53-0.22c-26.345,22.998-43.069,56.753-43.069,94.478 c0,45.737,24.547,85.642,61.104,107.578c10.595,6.359,22.185,11.179,34.521,14.2c6.216,1.521,12.584,2.63,19.125,3.185 c3.557,0.306,7.124,0.545,10.758,0.545c23.581,0,45.556-6.617,64.403-17.93c8.97-5.384,17.279-11.743,24.613-19.125 c13.244-13.33,23.409-29.653,29.635-47.812c4.37-12.766,6.856-26.393,6.856-40.641c0-8.3-0.852-16.4-2.391-24.25 c-0.134-0.688-0.268-1.368-0.421-2.046c-12.097-56.687-62.405-99.211-122.696-99.211c-2.438,0-4.811,0.229-7.21,0.363l0.334-0.277 c-2.658-3.203-5.183-6.034-7.688-8.826c-2.755-3.069-5.394-5.852-7.976-8.443c-14.545-14.631-26.44-21.717-36.663-21.87 L37.546,5.799c-2.085-4.858-7.698-7.096-12.556-5.03c-4.857,2.075-7.114,7.698-5.03,12.556L84.163,163.312z M115.786,182.284 c2.419,1.999,5.135,4.446,8.224,7.535c2.285,2.276,4.791,4.944,7.478,7.918c-13.244,3.155-25.637,8.405-36.882,15.386 c-0.277-3.72-0.393-7.354-0.402-10.873c-0.009-3.911,0.096-7.688,0.402-11.063c0.096-1.109,0.258-2.046,0.392-3.08 c0.487,0.784,1.042,1.463,1.702,2.066c1.75,1.578,3.979,2.543,6.35,2.543c1.253,0,2.534-0.249,3.758-0.774 c3.52-1.501,5.604-4.877,5.729-8.463c0.048-1.368-0.134-2.754-0.698-4.093l-0.096-0.22 C112.975,180.037,114.323,181.07,115.786,182.284z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgBricksWallAndDemolitionBall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "608.963px",
    height: "608.963px",
    viewBox: "0 0 608.963 608.963",
    style: {
      enableBackground: "new 0 0 608.963 608.963"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBricksWallAndDemolitionBall);
export default __webpack_public_path__ + "static/media/bricks-wall-and-demolition-ball.47dd75a3.svg";
export { ForwardRef as ReactComponent };